import type { Gate, Limit } from './allowances';

type BillingDecimalLike = string | { toString(): string };

export type BillingPriceTier = {
  flat_amount: number | null;
  flat_amount_decimal?: BillingDecimalLike | null;
  unit_amount: number | null;
  unit_amount_decimal?: BillingDecimalLike | null;
  up_to: number | null;
};

export const PlanName = {
  FREE: 'FREE',
  PRO: 'PRO',
  STARTER: 'STARTER',
  PREMIUM: 'PREMIUM',
  CUSTOM: 'CUSTOM',
} as const;

export type PlanName = (typeof PlanName)[keyof typeof PlanName];

export const PlanState = {
  TRIAL: 'TRIAL',
  ACTIVE: 'ACTIVE',
} as const;

export type PlanState = (typeof PlanState)[keyof typeof PlanState];

export const PlanFrequency = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
} as const;

export type PlanFrequency = (typeof PlanFrequency)[keyof typeof PlanFrequency];

export type PlanDefinitionWithIds = {
  tieredMonthlyPrice?: BillingPriceTier[];
  tieredYearlyPrice?: BillingPriceTier[];
  priceMonthlyId?: string;
  priceYearlyId?: string;
  limits: Record<Limit, number>;
  gates: Record<Gate, boolean>;
};

export type PlansDefinitions = Record<
  PlanName,
  Pick<
    PlanDefinitionWithIds,
    'tieredMonthlyPrice' | 'tieredYearlyPrice' | 'limits' | 'gates'
  >
>;

export type PlansDefinitionsWithIds = Record<PlanName, PlanDefinitionWithIds>;

export type BillingInfo = {
  currentPlan: PlanName;
  currentPlanFrequency: PlanFrequency | null;
  isOnTrial: boolean;
  trialEndDate: Date | null;
  currency: 'euro' | 'dollar';
  plans: PlansDefinitions;
};
